import { useFormContext } from "react-hook-form";
import Checkbox from "@/components/Checkbox/Checkbox";
import Checkboxes from "@/components/Checkbox/Checkboxes";
import { weekdaySchema, type IWeekday } from "@/api/Activities";
import { weekdayDictionary } from "./schedulingModels";
import { useLingui } from "@lingui/react/macro";

export type IWeekdaysPickerFields = {
  weekdays: IWeekday[];
};

export const WeekdaysPicker = () => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
  } = useFormContext<IWeekdaysPickerFields>();

  const weekdaysField = register(`weekdays`, {
    required: {
      value: true,
      message: t`Ange minst en veckodag`,
    },
  });

  return (
    <Checkboxes
      errorMessage={errors.weekdays?.message}
      orientation="horizontal"
      legend={t`Upprepa på`}
    >
      <Checkbox
        label={{ text: t(weekdayDictionary.Monday.short) }}
        {...weekdaysField}
        value={weekdaySchema.enum.Monday}
        visualStyle="framed"
      />
      <Checkbox
        label={{ text: t(weekdayDictionary.Tuesday.short) }}
        {...weekdaysField}
        value={weekdaySchema.enum.Tuesday}
        visualStyle="framed"
      />
      <Checkbox
        label={{ text: t(weekdayDictionary.Wednesday.short) }}
        {...weekdaysField}
        value={weekdaySchema.enum.Wednesday}
        visualStyle="framed"
      />
      <Checkbox
        label={{ text: t(weekdayDictionary.Thursday.short) }}
        {...weekdaysField}
        value={weekdaySchema.enum.Thursday}
        visualStyle="framed"
      />
      <Checkbox
        label={{ text: t(weekdayDictionary.Friday.short) }}
        {...weekdaysField}
        value={weekdaySchema.enum.Friday}
        visualStyle="framed"
      />
      <Checkbox
        label={{ text: t(weekdayDictionary.Saturday.short) }}
        {...weekdaysField}
        value={weekdaySchema.enum.Saturday}
        visualStyle="framed"
      />
      <Checkbox
        label={{ text: t(weekdayDictionary.Sunday.short) }}
        {...weekdaysField}
        value={weekdaySchema.enum.Sunday}
        visualStyle="framed"
      />
    </Checkboxes>
  );
};
